import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  update(event) {
    // 1. Find the calendar element
    const calendarEl = document.querySelector('[data-controller="program-schedule-calendar"]');
    if (!calendarEl) return;

    // 2. Get the Stimulus instance of the calendar
    const calendarController = this.application.getControllerForElementAndIdentifier(
      calendarEl,
      "program-schedule-calendar"
    );

    // 3. Tell the calendar to refresh (which uses its internal requestUrl getter)
    if (calendarController) {
      calendarController.updateHour();
    }
  }
}
